var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MaterialForm"},[_c('DashboardEditSection',{attrs:{"title":"Information"}},[_c('FormInput',{attrs:{"label":"Name","errors":_vm.$v.name.$error ? [
                !_vm.$v.name.required && 'Material name is required',
            ] : null,"required":""},model:{value:(_vm.$v.name.$model),callback:function ($$v) {_vm.$set(_vm.$v.name, "$model", $$v)},expression:"$v.name.$model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }